import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpCallerService, ListResponseModel } from '@overflo1/frame-frontend';
import { environment } from 'src/environments/environment';
import {FamilyModel} from "../models/family.model";

@Injectable({
  providedIn: 'root'
})
export class FamilyService extends HttpCallerService {

  constructor(
    protected override readonly http: HttpClient,
  ) {
    super(http, environment.backendBasePath);
  }

  async getAllFamilies() {
    return await this.get<FamilyModel[]>(`/family/get-all`);
  }

  async toggleFamilyEnableValue(familyId: number) {
    return await this.get<FamilyModel[]>(`/family/toggle-enable-value/${familyId}`);
  }
}
